import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = (token, userData) => {
    if (!token) return;

    localStorage.setItem("accessToken", token);
    localStorage.setItem("user", JSON.stringify(userData));

    setIsAuth(true);
    setUser(userData);
  };

  const logout = () => {
    localStorage.clear();
    setIsAuth(false);
    setUser(null);
  };


  useEffect(() => {
    syncAuthFromStorage();
    setLoading(false);
  }, []);

  useEffect(() => {
    const handleAuthUpdate = () => {
      syncAuthFromStorage();
    };

    window.addEventListener("auth-updated", handleAuthUpdate);

    return () => {
      window.removeEventListener("auth-updated", handleAuthUpdate);
    };
  }, []);

  const syncAuthFromStorage = () => {
    const token = localStorage.getItem("accessToken");
    const storedUser = localStorage.getItem("user");

    if (token && storedUser) {
      setIsAuth(true);
      setUser(JSON.parse(storedUser));
    } else {
      setIsAuth(false);
      setUser(null);
    }
  };

  useEffect(() => {
    console.log("auth updated");
  }, [isAuth, user]);

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ isAuth, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
